import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import AddCircle from "@mui/icons-material/AddCircle";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import CircularProgress from "@mui/material/CircularProgress";

import { objectToQueryString, baseUrl, apiHelper } from "helpers/util";

import ColumnBox from "components/ColumnBox";
import RowBox from "components/RowBox";
import SmallestHeading from "components/SmallestHeading";

export default function Form(props) {
  const [dataRows, setDataRows] = useState([]);
  window.init = function (userDetails) {
    console.log("Init is called");
    console.log("Data received: " + JSON.stringify(userDetails));
    refreshHistory(userDetails);
  };
  const refreshHistory = function (userDetails) {
    let un = userDetails["record_id"];
    let apiUrl = `${baseUrl}/.netlify/functions/fc_app_statistics`;
    let apiPromise = apiHelper.get({ url: apiUrl, params: { link_token: un } });

    apiPromise.then((response) => {
      if (response.status) {
        console.log(JSON.stringify(response.json));
        setDataRows(response.json.data);
      } else {
        console.log(response.json);
      }
    });
  };

  return (
    <RowBox
      sx={{
        justifyContent: "space-between",
        flexWrap: "nowrap",
        padding: "15px",
      }}
    >
      <ColumnBox>
        <SmallestHeading>Period Count</SmallestHeading>
        {dataRows.map((dr, i) => (
          <Box key={i}>{dr["fields"]["Period"]}</Box>
        ))}
      </ColumnBox>
      <ColumnBox>
        <SmallestHeading>Total Count</SmallestHeading>
        {dataRows.map((dr, i) => (
          <Box sx={{ alignSelf: "flex-end" }} key={i}>
            {dr["fields"]["Total Count"]}
          </Box>
        ))}
      </ColumnBox>
    </RowBox>
  );
}
